module.exports = __webpack_public_path__ + "img/p17_2.75adb88d.png";